
import { mapGetters, mapState } from 'vuex'

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters('profile', [
            'role'
        ]),
        ...mapState('booking', [
            'bookingData'
        ]),
        active() {
            return this.bookingData.times.find(el => el.time === this.item.start)
        }
    },
    methods: {
        toggle() {
            if (!this.item.disabled) {
                this.$emit('toggleTime')
            }
        }
    }
}
